// extracted by mini-css-extract-plugin
export default {"search":"ArtWarehouseSearch_search__FskSk","searchIcon":"ArtWarehouseSearch_searchIcon__JpsS3"};